<template>
  <div class="dividends-table-wrapper">
    <slot></slot>
    <RkTable
      class="dividend-table"
      :data="sliceEventList"
      :showFooter="showFooter"
      :loading="loading"
      :finished="finished"
    >
      <template #footer>
        <ShowMoreButton v-if="eventList.length > initLength" v-model="isMore" />
      </template>
      <RkTableColumn prop="paymentDate" label="派息日" fixed align="left" :width="`${postcssPatch(100)}`">
        <template #default="{ row }">{{
          $digitjs(row[market === 'hs' ? 'bonusDate' : 'paymentDate']).isNull()
        }}</template>
      </RkTableColumn>
      <RkTableColumn prop="plan" label="分配方案" align="left" :width="`${postcssPatch(170)}`">
        <template #default="{ row }">{{ $digitjs(row.plan).isNull() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="recordDate" label="股权登记日" :width="`${postcssPatch(100)}`">
        <template #default="{ row }">{{ $digitjs(row.recordDate).isNull() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="exDate" label="除净日" :width="`${postcssPatch(100)}`">
        <template #default="{ row }">{{ $digitjs(row.exDate).isNull() }}</template>
      </RkTableColumn>
    </RkTable>
  </div>
</template>

<script>
import ShowMoreButton from '@/components/common/ShowMoreButton.vue'
import { postcssPatch } from '@/utils/postcssPatch'
export default {
  components: { ShowMoreButton },
  props: {
    showFooter: {
      type: Boolean,
      default: true
    },
    total: {
      type: Number
    },
    initLength: {
      type: Number,
      default: 20
    }
  },
  data() {
    return {
      loading: false,
      finished: false,
      isMore: false,
      eventList: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    sliceEventList() {
      if (this.total) {
        return this.eventList
      } else {
        return this.isMore ? this.eventList : this.eventList.slice(0, this.initLength)
      }
    }
  },
  created() {
    this.getEventList()
  },
  methods: {
    postcssPatch,
    async getEventList() {
      this.loading = true
      const res = await this.$post(this.$api.f10[this.market] + '/summary/ca-dividends', {
        startDate: '1990-01-01',
        symbol: this.symbol
      })
      this.eventList = res.data?.slice(0, this.total) ?? []
      this.finished = true
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.dividends-table-wrapper {
  background: var(--bg-color-2);
}

.dividend-table {
  --table-tbody-font-size: 13px;
}
</style>
